import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
// import { LoginComponent } from './login/login.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LoginComponent} from './login/login.component';
import {RegisterComponent} from './register/register.component';
import {AuthenticationRoutingModule} from "./authentication-routing.module";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {ForgotPasswordComponent} from './forgot-password/forgot-password.component';
import {VerifyEmailComponent} from './verify-email/verify-email.component';
import {EmailVerficationStatusComponent} from './email-verfication-status/email-verfication-status.component';
import {AuthMethodsComponent} from './auth-methods/auth-methods.component';
import {AuthenticationComponent} from './authentication/authentication.component';
import {AuthEmailMethodComponent} from './auth-email-method/auth-email-method.component';
import {VerifyEmailFormComponent} from './verify-email-form/verify-email-form.component';
import {AuthSocialMethodComponent} from './auth-social-method/auth-social-method.component';

// import { HotToastModule } from '@ngneat/hot-toast';


@NgModule({
	declarations: [
		LoginComponent,
		RegisterComponent,
		ForgotPasswordComponent,
		VerifyEmailComponent,
		EmailVerficationStatusComponent,
		AuthMethodsComponent,
		AuthenticationComponent,
		AuthEmailMethodComponent,
		VerifyEmailFormComponent,
		AuthSocialMethodComponent
	],
	imports: [
		CommonModule,
		AuthenticationRoutingModule,
		FormsModule,
		ReactiveFormsModule,
		NgOptimizedImage,
		MatCheckboxModule
	]
})
export class AuthenticationModule {
}
